module.exports = __webpack_public_path__ + "static/media/error_boundary_img.0ba2a3da.svg";